import React from 'react'
import Profile from '../Components/Profile/Profile'

const ProfileView = () => {
  return (
    <div>
        <Profile />
    </div>
  )
}

export default ProfileView